import React, { useState, useEffect } from 'react';
import {
  Box,
  Paper,
  Typography,
  CircularProgress,
  Alert,
  Divider
} from '@mui/material';
import { useAuth } from '../auth/useAuth';

const CashBox = () => {
  const { api, user } = useAuth();
  const [cashBox, setCashBox] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchCashBox();
  }, []);

  const fetchCashBox = async () => {
    try {
      setLoading(true);
      const response = await api.get('/transactions/cash-box/my-box');
      setCashBox(response.data);
    } catch (error) {
      console.error('שגיאה בטעינת הקופה:', error);
      setError('שגיאה בטעינת פרטי הקופה');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" p={3}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ m: 2 }}>
        {error}
      </Alert>
    );
  }

  return (
    <Paper elevation={3} sx={{ p: 3, m: 2 }}>
      <Typography variant="h5" gutterBottom align="center" color="primary">
        💰 הקופה שלי
      </Typography>
      
      <Divider sx={{ mb: 2 }} />
      
      <Box textAlign="center">
        <Typography variant="h3" color="success.main" gutterBottom>
          ${cashBox?.currentAmount || 0}
        </Typography>
        <Typography variant="body1" color="text.secondary" gutterBottom>
          יתרה נוכחית
        </Typography>
      </Box>

      <Divider sx={{ my: 2 }} />

      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box textAlign="center">
          <Typography variant="h6" color="info.main">
            ${cashBox?.totalCollected || 0}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            סה"כ נאסף
          </Typography>
        </Box>
        
        <Box textAlign="center">
          <Typography variant="body1" color="text.primary">
            {cashBox?.lastResetAt 
              ? new Date(cashBox.lastResetAt).toLocaleDateString('he-IL')
              : 'לא בוצע איפוס'
            }
          </Typography>
          <Typography variant="body2" color="text.secondary">
            איפוס אחרון
          </Typography>
        </Box>
      </Box>

      {cashBox?.currentAmount > 100 && (
        <Alert severity="warning" sx={{ mt: 2 }}>
          יתרה גבוהה! יש לדווח למנהל לאיפוס הקופה
        </Alert>
      )}
    </Paper>
  );
};

export default CashBox;
